"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var VidyardIcon = function VidyardIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".cls-1", "{", "fill:#5b627d", "}", ".cls-2", "{", "fill:#46db83", "}", ".cls-3", "{", "fill:#fff", "}")), /*#__PURE__*/_react.default.createElement("title", null, "Full"), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M67.59 32.19a45.65 45.65 0 0 1 10.91 1.32 1.91 1.91 0 0 0 2.21-1.17 1.91 1.91 0 0 0-1.33-2.54A49.34 49.34 0 0 0 56 29.74a1.91 1.91 0 0 0-1.33 2.55 1.89 1.89 0 0 0 2.2 1.17 45.66 45.66 0 0 1 10.72-1.27zM91.14 37.35a1.93 1.93 0 0 0 .86 1.91 45.77 45.77 0 1 1-48.69-.11 1.92 1.92 0 0 0 .89-1.92 1.91 1.91 0 0 0-2.88-1.33A49.6 49.6 0 1 0 94 36a1.91 1.91 0 0 0-2.86 1.35z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-2",
    d: "M77.86 50.35a52.39 52.39 0 0 0-7.32-1c-1 0-2-.08-3-.08a52 52 0 0 0-8.89.75 53.06 53.06 0 0 0-17.47 6.48 52.45 52.45 0 0 0-9.77 7.38 3.26 3.26 0 0 0-1 2.76l4.75 37.87a41.87 41.87 0 0 0 64.85 0l.72-5.73a14 14 0 0 0 7.2-12.57 14.47 14.47 0 0 0-4.31-10.5l1.14-9.07a3.2 3.2 0 0 0-.93-2.7 52.17 52.17 0 0 0-26-13.59z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-2",
    d: "M63 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.53-4.85-10.53-11.3s4.53-11.3 10.53-11.3a10.13 10.13 0 0 1 6.83 2.57 11.56 11.56 0 0 1 3.69 8.73A11.15 11.15 0 0 1 63 96.36zM99.43 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.52-4.85-10.52-11.3s4.52-11.3 10.52-11.3a10.13 10.13 0 0 1 6.83 2.57 11.53 11.53 0 0 1 3.69 8.73 11.15 11.15 0 0 1-5.75 10.15z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M50.44 52.22l-3.35-21.43a6.4 6.4 0 0 1-1.79-12.62A6.48 6.48 0 0 1 53 22.8a6.41 6.41 0 0 1-3.27 7.29l7.8 20.21a51.84 51.84 0 0 0-7.08 1.92zM77.86 50.34l7.81-20.25a6.4 6.4 0 0 1 4.76-11.82 6.4 6.4 0 0 1-2.14 12.52c-1 6.23-2.19 14-3.37 21.49a53.86 53.86 0 0 0-7.06-1.95z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-3",
    d: "M63 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.53-4.85-10.53-11.3s4.53-11.3 10.53-11.3a10.13 10.13 0 0 1 6.83 2.57 11.56 11.56 0 0 1 3.69 8.73A11.15 11.15 0 0 1 63 96.36zM99.43 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.52-4.85-10.52-11.3s4.52-11.3 10.52-11.3a10.13 10.13 0 0 1 6.83 2.57 11.53 11.53 0 0 1 3.69 8.73 11.15 11.15 0 0 1-5.75 10.15z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M95.49 82.05a3.26 3.26 0 0 0-2.75-1.59A3.22 3.22 0 0 0 90 81.92a7.18 7.18 0 0 0-1.17 3.86 6.72 6.72 0 0 0 1.07 4 3.12 3.12 0 0 0 5.47 0A6.12 6.12 0 0 0 96.55 86a6.6 6.6 0 0 0-1.06-3.95z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "cls-3",
    cx: "93.43",
    cy: "84.14",
    r: "1.32"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M59.08 82.05a3.26 3.26 0 0 0-2.75-1.59 3.22 3.22 0 0 0-2.72 1.46 7.18 7.18 0 0 0-1.17 3.86 6.72 6.72 0 0 0 1.07 4 3.12 3.12 0 0 0 5.47 0A6.12 6.12 0 0 0 60.14 86a6.6 6.6 0 0 0-1.06-3.95z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "cls-3",
    cx: "57.01",
    cy: "84.14",
    r: "1.32"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M110.22 119.79a1.42 1.42 0 0 0 .84-1.35c0-1.06-.76-1.55-1.9-1.55h-1.52a.64.64 0 0 0-.64.64v3.34a.64.64 0 0 0 .64.64.65.65 0 0 0 .64-.64v-.81h.59l1 1.21a.62.62 0 0 0 .49.24.63.63 0 0 0 .64-.61.65.65 0 0 0-.17-.45zm-1.13-.74h-.81V118h.81c.44 0 .69.2.69.54s-.25.51-.69.51z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M108.88 123.88a4.69 4.69 0 1 1 4.61-4.69 4.65 4.65 0 0 1-4.61 4.69zm0-8.55a3.86 3.86 0 1 0 3.8 3.86 3.83 3.83 0 0 0-3.8-3.86z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M110.22 119.79a1.42 1.42 0 0 0 .84-1.35c0-1.06-.76-1.55-1.9-1.55h-1.52a.64.64 0 0 0-.64.64v3.34a.64.64 0 0 0 .64.64.65.65 0 0 0 .64-.64v-.81h.59l1 1.21a.62.62 0 0 0 .49.24.63.63 0 0 0 .64-.61.65.65 0 0 0-.17-.45zm-1.13-.74h-.81V118h.81c.44 0 .69.2.69.54s-.25.51-.69.51z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M108.88 123.88a4.69 4.69 0 1 1 4.61-4.69 4.65 4.65 0 0 1-4.61 4.69zm0-8.55a3.86 3.86 0 1 0 3.8 3.86 3.83 3.83 0 0 0-3.8-3.86z"
  }));
};

VidyardIcon.defaultProps = {
  id: "Layer_1",
  'data-name': "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 135.19 145.55"
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    input: {
      backgroundColor: 'transparent',
      '& .MuiInputBase-root': {
        backgroundColor: palette.common.white
      }
    },
    vidyardBox: {
      height: 130,
      width: '100%',
      marginRight: spacing(2),
      border: "2px dotted ".concat(palette.grey.timberWolf),
      backgroundColor: palette.common.white
    },
    boxImage: {
      width: 240,
      height: '100%',
      border: 'none',
      '& > img': {
        borderRadius: 5
      }
    }
  };
});

var GiftVideoMessageForm = function GiftVideoMessageForm(_ref2) {
  var type = _ref2.type,
      giftId = _ref2.giftId,
      vidyardVideo = _ref2.vidyardVideo,
      vidyardImage = _ref2.vidyardImage,
      videoMessage = _ref2.videoMessage,
      errors = _ref2.errors,
      onVideoEnabled = _ref2.onVideoEnabled,
      onVidyardSelect = _ref2.onVidyardSelect,
      onVidyardRemove = _ref2.onVidyardRemove,
      onSetLocalVideoMessage = _ref2.onSetLocalVideoMessage;

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      vidyardClientId = _useGiftContext.vidyardClientId;

  var classes = useStyles();
  var radioWrapperProps = {
    p: 0,
    pl: 3
  };

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var vidyardIcon = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      textAlign: "center",
      mr: 2
    }, /*#__PURE__*/_react.default.createElement(VidyardIcon, {
      width: 40,
      height: 40
    }));
  }, []);
  var handleShowVidyardPopup = (0, _react.useCallback)(function () {
    trackEvent('Sender - Vidyard Integration Gifting Flow. Open popup for select video');
  }, [trackEvent]);
  var handleRemoveVidyardVideo = (0, _react.useCallback)(function () {
    trackEvent('Sender - Vidyard Integration Gifting Flow. Remove selected video', {
      image: vidyardImage,
      link: vidyardVideo
    });
    onVidyardRemove();
  }, [trackEvent, onVidyardRemove, vidyardImage, vidyardVideo]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    value: type,
    onChange: onVideoEnabled
  }, /*#__PURE__*/_react.default.createElement(_ui.RadioWithContent, {
    color: "primary",
    isActive: type === _ui.VIDEO_TYPE_VIDYARD,
    value: _ui.VIDEO_TYPE_VIDYARD,
    label: "Add or record Vidyard video",
    iconNode: vidyardIcon,
    wrapperProps: radioWrapperProps
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_ui.VidyardIntegration, {
    levelName: "giftingFlow",
    levelObjectId: giftId,
    handleSelect: onVidyardSelect,
    onShowModal: handleShowVidyardPopup,
    onRemove: handleRemoveVidyardVideo,
    image: vidyardImage,
    link: vidyardVideo,
    vidyardClientId: vidyardClientId,
    overrideClasses: {
      box: classes.vidyardBox,
      boxImage: classes.boxImage
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, errors && errors.vidyard_video && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    error: true
  }, errors.vidyard_video.join(', '))))), /*#__PURE__*/_react.default.createElement(_ui.RadioWithContent, {
    color: "primary",
    isActive: type === _ui.VIDEO_TYPE_EMBED,
    value: _ui.VIDEO_TYPE_EMBED,
    label: "Embed video link",
    wrapperProps: radioWrapperProps
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    my: 2,
    mr: 2,
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_ui.BaseField, {
    value: videoMessage,
    name: "recipient_video",
    label: "Gift Invitation Landing Page Video Link",
    placeholder: "Input gift invitation landing page video link",
    fullWidth: true,
    className: classes.input,
    errors: errors,
    onChange: onSetLocalVideoMessage
  }), /*#__PURE__*/_react.default.createElement(_ui.EmbedVideoTip, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    mt: 2
  }))), /*#__PURE__*/_react.default.createElement(_ui.RadioWithContent, {
    color: "primary",
    isActive: type === _ui.VIDEO_TYPE_DISABLED,
    value: _ui.VIDEO_TYPE_DISABLED,
    label: "Do not use a video",
    wrapperProps: radioWrapperProps
  })));
};

GiftVideoMessageForm.propTypes = {
  giftId: _propTypes.default.number.isRequired,
  type: _propTypes.default.oneOf([_ui.VIDEO_TYPE_DISABLED, _ui.VIDEO_TYPE_EMBED, _ui.VIDEO_TYPE_VIDYARD]),
  videoMessage: _propTypes.default.string.isRequired,
  vidyardImage: _propTypes.default.string.isRequired,
  vidyardVideo: _propTypes.default.string.isRequired,
  onVideoEnabled: _propTypes.default.func.isRequired,
  onSetLocalVideoMessage: _propTypes.default.func.isRequired,
  onVidyardSelect: _propTypes.default.func.isRequired,
  onVidyardRemove: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object
};
GiftVideoMessageForm.defaultProps = {
  type: null,
  errors: {}
};
var _default = GiftVideoMessageForm;
exports.default = _default;